import { useEffect, useState } from "react";
import CustomTable from "../../widgets/table/index";
import HeaderSection from "../common/headerSection";
import PageHeader from "../common/pageHeader";
import { userService } from "../../service/plateServices";
import Pagination from "../../widgets/pagination";
import { EsignModal } from "../../widgets/alertModal";

import { dashboardServices } from "../../service/dashboard";

import { scheduleService } from "../../service/scheduleService";
import { DEFAULT_PAGE_SIZE } from "../../constants/constants";
import { useTranslation } from "react-i18next";
import CustomToast from "../../widgets/toaster";
import { columnsHistory, columnsNew } from "././partials/columns";
import PlateDetailsViewModel from "../lab_operator/labReport/models/plateDetailsModel";
import CustomLoader from "../../widgets/loader/loader";
import { helperFunctions } from "../../utils/helper";

type LabtestStatType = {
  pending_plates_for_lab_approval: number;
  lab_approved_plates: number;
  escalations: number;
};


const EnvironmentalFloraReport = () => {

  const { t } = useTranslation();
  
  const currentDate = new Date().toISOString().split('T')[0];
  const [tab, setTab] = useState("1");
  const [showView, setShowView] = useState(false);
  const [historyView, setHistoryView] = useState(false);
  const [plateDetails, setPlateDetails] = useState<Array<any>>([]);
  const [plateDetailsHistory, setPlateDetailsHistory] = useState<Array<any>>([]);
  const [useEffectRequired, setUseEffectRequired] = useState(false);
  const [plateBatches, setPlateBatches] = useState([]);
  const [plateSerielNum, setPlateSerielNums] = useState([]);
  const [keyWord, setkeyWord] = useState("");
  const [historyKeyWord, setHistoryKeyWord] = useState("");
  const [userId, setUserId] = useState<number>(0);
  const [showEsignAlert, setShowEsignAlert] = useState(false)
  const [labtestStat, setLabTestStat] = useState<LabtestStatType | null>(null);
  const [selectedTab, setSelectedTab] = useState<number | null>(null);
  const [plateId, setPlateId] = useState("");
  const [activityType, setActivityType] = useState<Array<any>>([]);
  const [areaList, setAreaList] = useState<Array<any>>([]);
  const [activityTypeId, setActivityTypeId] = useState("");
  const [areaId, setAreaId] = useState("");
  const [batchCode, setBatchCode] = useState("");
  const [fromDate, setFromDate] = useState(
    new Date(new Date().setDate(new Date().getDate() - 7))
      .toISOString()
      .split("T")[0]
  );
  const [toDate, setToDate] = useState(currentDate);
  const [activityTypeIdHistory, setActivityTypeIdHistory] = useState("");
  const [areaIdHistory, setAreaIdHistory] = useState("");
  const [batchCodeHistory, setBatchCodeHistory] = useState("");
  const [fromDateHistory, setFromDateHistory] = useState(
    new Date(new Date().setDate(new Date().getDate() - 7))
      .toISOString()
      .split("T")[0]
  );
  const [toDateHistory, setToDateHistory] = useState(currentDate);



  // pagination
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  //history pagination
  const [historyPage, setHistoryPage] = useState(1);
  const [historyPageSize, setHistoryPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [historyTotalPages, setHistoryTotalPages] = useState(0);
  const [historyTotalElements, setHistoryTotalElements] = useState(0);
  const [esignParams, setEsignParams] = useState<{ selectedIds: string; status: string } | null>(null);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const [prodScheduleList, setProdScheduleList] = useState<Array<any>>([]);
  const [productList, setProductList] = useState<Array<any>>([]);
  const [scheduleProductId, setScheduleProductId] = useState("");
  const [productId, setProductId] = useState("");
  const [sort, setSort] = useState("updated_at");
  const [order, setOrder] = useState("desc");
  const [sortHistory, setSortHistory] = useState("updated_at");
  const [orderHistory, setOrderHistory] = useState("desc");
  const [historyScheduleProductId, setHistoryScheduleProductId] = useState("");
  const [historyProductId, setHistoryProductId] = useState("");
  const sortRemoveList=["colony_count","colony_type","organism_type","genus","species","strain","flora_status"]
  const sortRemoveListHistory=["colony_count","colony_type","organism_type","genus","species","strain","flora_status","approved_user_name","approved_date"]
 
//  useEffect (() => {
//     var storedData = localStorage.getItem('userDetails');

//     if(storedData) {
//       var storedObject = JSON.parse(storedData);
//       setUserId(storedObject[0].id)
//     }
//     getLabtestStatuDetails();
//     getLabApprovedPlates();
//     getLabPlatesHistory();
//     listPlateBatch();
//     listSerialNumber();
//     getActivityTypeList();
//     getAreaList();
//     getProductionSchedules();
//     getProductList();

//     setUseEffectRequired(false)
//   }, [useEffectRequired]) 
 
 
  // Render initial api calls 
  useEffect (() => {
    var storedData = localStorage.getItem('userDetails');

    if(storedData) {
      var storedObject = JSON.parse(storedData);
      setUserId(storedObject[0].id)
    }
    getLabtestStatuDetails();
    getActivityTypeList();
    getAreaList();
    getProductionSchedules();
  }, []);

  // Handle tab change
  const handleTabChange = (newTab: string) => {
    setTab(newTab);
    
    // Reset pagination and sorting when switching tabs
    if (newTab === "1") {
      // Reset history tab states
      setHistoryPage(1);
      setHistoryPageSize(DEFAULT_PAGE_SIZE);
      setSortHistory("updated_at");
      setOrderHistory("desc");
      // Reset history filters if needed
      setActivityTypeIdHistory("");
      setAreaIdHistory("");
      setBatchCodeHistory("");
      setFromDateHistory(new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().split("T")[0]);
      setToDateHistory(currentDate);
      setHistoryScheduleProductId("");
      setHistoryProductId("");
      setHistoryKeyWord("");
      
      // Load data for request tab
      getLabApprovedPlates();
    } else if (newTab === "2") {
      // Reset request tab states
      setPage(1);
      setPageSize(DEFAULT_PAGE_SIZE);
      setSort("updated_at");
      setOrder("desc");
      // Reset request filters if needed
      setActivityTypeId("");
      setAreaId("");
      setBatchCode("");
      setFromDate(new Date(new Date().setDate(new Date().getDate() - 7)).toISOString().split("T")[0]);
      setToDate(currentDate);
      setScheduleProductId("");
      setProductId("");
      setkeyWord("");
      
      // Load data for history tab
      getLabPlatesHistory();
    }
  };

  // Load data for request tab
  useEffect(() => {
    if (tab === "1") {
      getLabApprovedPlates();
      setUseEffectRequired(false)
    }
  }, [tab, page, pageSize, sort, order, activityTypeId, areaId, batchCode, fromDate, toDate, 
      scheduleProductId, productId, keyWord, useEffectRequired]);

  // Load data for history tab
  useEffect(() => {
    if (tab === "2") {
      getLabPlatesHistory();
    }
  }, [tab, historyPage, historyPageSize, sortHistory, orderHistory, activityTypeIdHistory, 
      areaIdHistory, batchCodeHistory, fromDateHistory, toDateHistory, historyScheduleProductId, 
      historyProductId, historyKeyWord, useEffectRequired]);

  // Load initial data only once when component mounts
  useEffect(() => {
    if (plateBatches.length === 0) {
      listPlateBatch();
      listSerialNumber();
      getProductList();
    }
  }, []);

  //get lab report stat details on top 
  const getLabtestStatuDetails = async () => {
    try {
      const response = await dashboardServices.getLabtestStatuDetails(); 
        if(response.status && response.statusCode === 200){
          setLabTestStat({
  
            pending_plates_for_lab_approval: response.data.pending_plates_for_lab_approval,
            lab_approved_plates : response.data.reviewed_plates_count,
            escalations : response.data.escalations,
            });
      }
    } catch (error) {
      console.error(error);
    }
    };
  
  // on click request table 
  const handleViewClick = (id: string, viewValue: boolean) => {
    const updatedData = plateDetails.filter((row) => row.slno === id);
    setPlateId(updatedData[0]?.plate_id)
    setShowView(viewValue);
  };

  // on click history table 
  const handleHistoryView = (id: string, viewValue: boolean) => {
    const updatedData = plateDetailsHistory?.filter((row) => row.slno === id);
    console.log(plateDetailsHistory, "plateDetailsHistory")
    setPlateId(updatedData[0]?.plate_id)
    setHistoryView(viewValue);
  };

  // get Activity Type List
    const getActivityTypeList = async () => {
      try {
      const response = await scheduleService.getActivityTypeList();
      if (response.status && response.statusCode === 200) {
          try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
              let rowData: any = response.data.map(
              (element: any, index: number) => {
                  return {
                  slno: index + 1,
                  id: element.id,
                  name: element.name,
                  };
              }
              );
              setActivityType(rowData);
          }
          } catch (error) {
          console.log(error);
          }
      } else {
          setActivityType([]);
      }
      } catch (error) {
      console.error("user response", error);
      }
    };

  //api call to get area list
  const getAreaList = async () => {
    try {
      const response = await scheduleService.getAreaList("id", "desc", "6,8,17");
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  id: element.id,
                  name: element.name,
                  grade_name: element.grade_name,
                };
              }
            );
            setAreaList(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setAreaList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  // get ProductionScheduleList
  const getProductionSchedules = async () => {
    try {
      const response = await scheduleService.getProductionSchedules();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  slno: index + 1,
                  id: element.id,
                  production_schedule_name: element?.production_schedule_name,
                  activity_type_id: element.activity_type_id,
                };
              }
            );
            setProdScheduleList(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setProdScheduleList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  //api call to get area list
  const getProductList = async () => {
    try {
      const response = await scheduleService.getProductList();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  id: element.id,
                  name: element.name,
                };
              }
            );
            setProductList(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setProductList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  //to get request main table listing 
  const getLabApprovedPlates = async () => {
      try {
        const response = await userService.getFloraLabApprovedPlates(page, pageSize,sort,order, keyWord, activityTypeId, areaId, batchCode, fromDate, toDate, scheduleProductId, productId);
        if(response.status && response.statusCode === 200){
          try {
              if ( Array.isArray(response.data) && response.data?.length > 0) {
                setTotalPages(response?.totalPages)
                setTotalElements(response?.totalElements)
                let rowData: any = [];
                let emptySpace = " "

                response.data.map((element: any, indexMain: number) => {
                  // Filter out empty colony data entries
                  const filteredColonyData = element.colony_data.filter((colony: any) => 
                    colony.organism_type || colony.genus_name || colony.species_name || 
                    colony.strain_name || colony.colony_type_name
                  );
                  
                  if (filteredColonyData.length > 0) {
                    filteredColonyData.forEach((detail: any, index: number) => {
                      rowData.push({
                        slno: index === 0 ? indexMain + 1 : emptySpace,
                        id : index === 0 ? element.id : emptySpace,
                        plate_id: index === 0 ? element.plate_id : emptySpace,
                        production_schedule: index === 0 ? element.production_schedule_name : emptySpace,
                        product_name: index === 0 ? element.product_name : emptySpace,
                        serial_number: index === 0 ? element.serial_number : emptySpace,
                        batch_code: index === 0 ? element.batch_number : emptySpace,
                        activity_type: index === 0 ? element.assigned_activity_name : emptySpace,
                        area_name: index === 0 ? element.area_name : emptySpace,
                        location_name: index === 0 ? element.assigned_location_name : emptySpace,
                        colony_count: index === 0 ? element.colony_count : emptySpace,
                        colony_type: detail.colony_type_name,
                        organism_type: detail.organism_type,
                        genus: detail.genus_name,
                        species: detail.species_name,
                        strain: detail.strain_name,
                        flora_status: index === 0 ? element.flora_status : emptySpace,
                      });
                    });
                  } else {
                    rowData.push({
                      slno: indexMain + 1, 
                      id : element.id,
                      production_schedule: element.production_schedule_name,
                      product_name: element.product_name,
                      serial_number: element.serial_number,
                      batch_code: element.batch_number,
                      activity_type: element.assigned_activity_name,
                      area_name: element.area_name,
                      location_name: element.assigned_location_name,
                      colony_count: element.colony_count,
                      colony_type: element.colony_type_name,
                      organism_type: element.organism_type,
                      genus: element.genus_name,
                      species: element.species_name,
                      strain: element.strain_name,
                      flora_status: element.flora_status, 
                      plate_id: element.plate_id
                    });
                  }


                });
                setPlateDetails(rowData);
              }
            } catch (error) {
              console.log(error); 
            }
        } else {
          setPlateDetails([])
          setTotalPages(0)
          setTotalElements(0)
        }
      } catch (error) {
        console.error('Plate response', error);
      }
    };


    const handleSort = (key: string, value: boolean) => {
    setSort(key);
    if (value) {
      setOrder("asc");
    } else {
      setOrder("desc");
    }
    setUseEffectRequired(true);
  };

  //to get history table listing 
  const getLabPlatesHistory = async () => {
      try {
        const response = await userService.getFloraLabPlatesHistory(historyPage, historyPageSize,sortHistory,orderHistory, historyKeyWord, activityTypeIdHistory, areaIdHistory, batchCodeHistory, fromDateHistory, toDateHistory,historyScheduleProductId,historyProductId);
        if(response.status && response.statusCode === 200){
          try {
              if ( Array.isArray(response.data) && response.data?.length > 0) {
                setHistoryTotalPages(response?.totalPages)
                setHistoryTotalElements(response?.totalElements)
                let rowData: any = [];
                let emptySpace = " "
               
                response.data.map((element: any, indexMain: number) => {

                   // Filter out empty colony data entries
                  const filteredColonyData = element.colony_data.filter((colony: any) => 
                    colony.organism_type || colony.genus_name || colony.species_name || 
                    colony.strain_name || colony.colony_type_name
                  );
                     
                  if (filteredColonyData.length > 0) {
                    filteredColonyData.forEach((detail: any, index: number) => {
                      rowData.push({
                        slno: index === 0 ? indexMain + 1 : emptySpace,
                        id : index === 0 ? element.id : emptySpace,
                        production_schedule: index === 0 ? element.production_schedule_name : emptySpace,
                        product_name: index === 0 ? element.product_name : emptySpace,
                        serial_number: index === 0 ? element.serial_number : emptySpace,
                        batch_code: index === 0 ? element.batch_number : emptySpace,
                        activity_type: index === 0 ? element.assigned_activity_name : emptySpace,
                        area_name: index === 0 ? element.area_name : emptySpace,
                        location_name: index === 0 ? element.assigned_location_name : emptySpace,
                        plate_id: index === 0 ? element.plate_id : emptySpace,
                        colony_count: index === 0 ? element.colony_count : emptySpace,
                        colony_type: detail.colony_type_name,
                        organism_type: detail.organism_type,
                        genus: detail.genus_name,
                        species: detail.species_name,
                        strain: detail.strain_name,
                        flora_status: index === 0 ? element.flora_status : emptySpace,
                        approved_date: index === 0 ? helperFunctions.formatDate(element.approved_date,true) : emptySpace,
                        approved_by: index === 0 ? element.approved_user_name : emptySpace,
                      });
                    });
                  } else {
                    rowData.push({
                      slno: indexMain + 1, 
                      id : element.id,
                      production_schedule: element.production_schedule_name,
                      product_name: element.product_name,
                      serial_number: element.serial_number,
                      batch_code: element.batch_number,
                      activity_type: element.assigned_activity_name,
                      area_name: element.area_name,
                      location_name: element.assigned_location_name,
                      plate_id: element.plate_id,
                      colony_count: element.colony_count,
                      colony_type: element.colony_type_name,
                      organism_type: element.organism_type,
                      genus: element.genus_name,
                      species: element.species_name,
                      strain: element.strain_name,
                      flora_status: element.flora_status, 
                      approved_date: helperFunctions.formatDate(element.approved_date,true),
                      approved_by: element.approved_user_name,
                    });
                  }

                });
                setPlateDetailsHistory(rowData);
              }
            } catch (error) {
              console.log(error); 
            }
        } else {
          setPlateDetailsHistory([])
          setHistoryTotalPages(0)
          setHistoryTotalElements(0)
        }
      } catch (error) {
        console.error('Plate response', error);
      }
    };



    const handleSortHistory = (key: string, value: boolean) => {
    setSortHistory(key);
    if (value) {
      setOrderHistory("asc");
    } else {
      setOrderHistory("desc");
    }
    setUseEffectRequired(true);
  };

  //request table pagination 
  const handlePageChange = (newPage : any, pageSize?: number) => {
    setPage(newPage);
    if(pageSize) {
      setPageSize(pageSize)
    }
    setUseEffectRequired(true)
  };

  //history table pagination 
  const handleHistoryPageChange = (newPage : any, pageSize?: number) => {
    setHistoryPage(newPage);
    if(pageSize) {
      setHistoryPageSize(pageSize)
    }
    setUseEffectRequired(true)
  };

  //history table filter options 
  const handleFilter = (key: string, value: any) => {
    if (key === "search") {
      setkeyWord(value)
    } else if (key === "activityType") {
      setActivityTypeId(value)
    } else if (key === "FromDate") {
      setFromDate(value)
      setToDate("")
    } else if (key === "ToDate") {
      setToDate(value)
    } else if (key === "area") {
      setAreaId(value)
    } else if (key === "batch_code") {
      setBatchCode(value)
    } else if (key === "productionSchedule") {
      setScheduleProductId(value)
    } else if (key === "productName") {
      setProductId(value)
    }

    setUseEffectRequired(true)
  }

  //handle history table filter options 
  const handleHistoryFilter = (key: string, value: any) => {
    if (key === "search") {
      setHistoryKeyWord(value)
    } else if (key === "activityType") {
      setActivityTypeIdHistory(value)
    } else if (key === "FromDate") {
      setFromDateHistory(value)
      setToDateHistory("")
    } else if (key === "ToDate") {
      setToDateHistory(value)
    } else if (key === "area") {
      setAreaIdHistory(value)
    } else if (key === "batch_code") {
      setBatchCodeHistory(value)
    }else if (key === "productionSchedule") {
      setHistoryScheduleProductId(value)
    } else if (key === "productName") {
      setHistoryProductId(value)
    }
    setUseEffectRequired(true)
  }

  //list plate batch api for filter
  const listPlateBatch = async () => {
    try {
      const response = await userService.listPlateBatch();
      if(response.status && response.statusCode === 200){
        try {
            if ( Array.isArray(response.data) && response.data?.length > 0) {
              let rowData: any = response.data.map((element: any, index: number) => {
  
                return { 
                    value: element.batch_number,
                    label: element.batch_number ,
                };
              });
              setPlateBatches(rowData);
            }
          } catch (error) {
            console.log(error); 
          }
      }
    } catch (error) {
      console.error('Plate response', error);
    }
  }

  //list serial number api for filter 
  const listSerialNumber = async () => {
    try {
      const response = await userService.listSerialNumber();
      if(response.status && response.statusCode === 200){
        try {
            if ( Array.isArray(response.data) && response.data?.length > 0) {
              let rowData: any = response.data.map((element: any, index: number) => {
  
                return { 
                    value: element.serial_number,
                    label: element.serial_number ,
                };
              });
              setPlateSerielNums(rowData);
            }
          } catch (error) {
            console.log(error); 
          }
      }
    } catch (error) {
      console.error('Plate response', error);
    }
  }

  //on click on approve button in request 
  const handleApproveBtn = (selectedRows : any[]) => {
    const filteredPlateDetails = plateDetails.filter((item) => selectedRows.includes(item.slno));
    const selectedIds = filteredPlateDetails
        .filter((item) => item.id.trim() !== '')
        .map((item) => item.id)
        .join(',');
    setShowEsignAlert(true)
    const status = "36"
    setEsignParams({ selectedIds, status });
  }

  //on click on reject button in history 
  const handleRejectBtn = (selectedRows : any[]) => {
    const filteredPlateDetails = plateDetails.filter((item) => selectedRows.includes(item.slno));
    const selectedIds = filteredPlateDetails
        .filter((item) => item.id.trim() !== '')
        .map((item) => item.id)
        .join(',');
    const status = "37"
    setShowEsignAlert(true)
    setEsignParams({ selectedIds, status });
  }

  //on password confirmation modal trigger 
  const handleESignConfirm = async (remarks: string) => {
    if (!esignParams) return;
    const { selectedIds, status } = esignParams;
    setIsLoading(true);
    try{
    await changeLabReportStatus(selectedIds, status, remarks);
    }finally{
      setIsLoading(false);
    }
  };
  
  //on trigger approve or reject button function call 
  const changeLabReportStatus = async (selectedIds: any, status : any, approverRemarks: string) => {

    const dataToSend = {
        flora_ids : selectedIds,
        user_id : userId,
        flora_status : status,
        approver_remarks : approverRemarks,
        interface_name : "Environment Flora Report"
    }

    try {
      const response = await userService.changeFloraReportStatus(dataToSend);
      if(response.status && response.statusCode === 200){
        setToastMessage(response.message);
        setToastType("success");
      } else {
        setToastMessage(response.message);
        setToastType("error");
      }
      setShowToast(true);
    } catch (error) {
      console.error('Plate response', error);
    }
    setkeyWord("")
    setShowEsignAlert(false)
    setEsignParams(null);
    setUseEffectRequired(true)
  }

  //on box click 
  const handleBoxClick = (value : number) => {
    setSelectedTab(value)
  };

  return (
    <div>
      <HeaderSection />
      <PageHeader pageHeader={t("Environmental_Flora.title")} />
      <CustomToast
        show={showToast}
        onClose={() => setShowToast(false)}
        delay={5000}
        message={toastMessage}
        toastType={toastType}
      />
      {/* <div className="container-lab">      
              <div className="box-display" style={{ backgroundColor: selectedTab === 1 ? '#e0e0e0' : '' }} onClick={() => handleBoxClick(1)}>
                    <h3 className='lab-dash-head'>{t("labreport.pendingPlates")}</h3>
                    <p className='lab-dash-value' style={{color : "#CBB613"}} >{labtestStat?.pending_plates_for_lab_approval}</p>
              </div>
              <div className="box-display" style={{ backgroundColor: selectedTab === 2 ? '#e0e0e0' : '' }} onClick={() => handleBoxClick(2)}>
                    <h3 className='lab-dash-head'>{t("labreport.approvedPlates")}</h3>
                    <p className='lab-dash-value'style={{color : "#148E04"}} >{labtestStat?.lab_approved_plates}</p>
              </div>
      </div> */}
       {isLoading && <CustomLoader />}
      <div className='exceptionHandlingTab'>
        <button
          // onClick={() => setTab("1")}
          onClick={() => handleTabChange("1")}
          className={tab === "1" ? "selectedNavBtn" : "navBtn"}
        >
          {t("labreport.requests")}
        </button>
        <button
          // onClick={() => setTab("2")}
          onClick={() => handleTabChange("2")}
          className={tab === "2" ? "selectedNavBtn" : "navBtn"}
        >
          {t("labreport.history")}
        </button>
      </div>
      

      {/* lab report request */}
      {tab === "1" && (
        <div>    
          <div className=" mx-3 pe-2">
            <CustomTable
              data={plateDetails}
              columns={columnsNew}
              isEditable={false}
              totalElements={totalElements}
              isActionVisible={true}
              isViewVisible={true}
              onViewClick={handleViewClick}
              onFilterClick={handleFilter}
              approveButton={true}
              approveButtonText={t("buttons.approve")}
              rejectButton={true}
              rejectButtonText={t("buttons.reject")}
              tableHead={t("labreport.approvals")}
              isSeachable={true}
              plateBatch={plateBatches}
              plateSerialNumber={plateSerielNum}
              onStartClick={handleApproveBtn}
              onEndClick={handleRejectBtn}
              ActivityType={activityType}
              areaDropList={areaList}
              showToDateLabApproval={true}
              showFromDateLabApproval={true}
              dateType='date'
              showFullFilters={true}
              showLotCodeFilter={false}
              showSerielNoFilter={false}
              prodScheduleList={prodScheduleList}
              productList={productList}
              onSortClick={handleSort}
              removeSortList={sortRemoveList}

            />
          </div>
          <div>
            <Pagination
              page={page}
              totalPages={totalPages}
              handlePageChange={handlePageChange}
            />
          </div>

          <EsignModal 
            show={showEsignAlert}
            onHide={() => setShowEsignAlert(false)}
            onConfirm={handleESignConfirm}
            needRemraks={true}
            screenName={"Environmental Flora Approval"}
           />

          <PlateDetailsViewModel 
            showView={showView} 
            setShowView={(value: boolean) => setShowView(value)}
            apiType='plateById'
            plateId={plateId}
          />
        </div>
      )}

      {/* lab report history */}
      {tab === "2" && (
        <div>
          <div className=" mx-3 pe-2">
            <CustomTable
              data={plateDetailsHistory}
              columns={columnsHistory}
              isEditable={false}
              totalElements={historyTotalElements}
              isActionVisible={false}
              isViewVisible={true}
              onViewClick={handleHistoryView}
              tableHead={t("labreport.pageTitle")}
              onFilterClick={handleHistoryFilter}
              isSeachable={true}
              plateBatch={plateBatches}
              plateSerialNumber={plateSerielNum}
              ActivityType={activityType}
              areaDropList={areaList}
              showToDateFilter={true}
              showFromDateFilter={true}
              dateType='date'
              showFullFilters={true}
              showLotCodeFilter={false}
              showSerielNoFilter={false}
              onSortClick={handleSortHistory}
              prodScheduleList={prodScheduleList}
              productList={productList}
              removeSortList={sortRemoveListHistory}
            />
          </div>
          <div>
            <Pagination
              page={historyPage}
              totalPages={historyTotalPages}
              handlePageChange={handleHistoryPageChange}
            />
          </div>

          <PlateDetailsViewModel 
            showView={historyView} 
            setShowView={(value: boolean) => setHistoryView(value)}
            apiType='plateById'
            plateId={plateId}
          />
      </div>
      )}
    </div>
  );
};


export default EnvironmentalFloraReport;



